import React from "react";
import ProWorkHeader from "./ProWorkHeader";
import {
    SSWPReport as SSWP,
    SLGCheckList as SLG,
    UserProfile as UP,
    pdfViewer,
    TMPlan as TM,
    JobPackV3,
    ToolBoxProfile,
    HD16Inspection as HD,
    DailyWorksheet as DW,
    VehicleCheckSheet as VCS,
    BlockVehicle as BV,
    VehicleTrailerCheck as VTC,
    JobPackManager as JPM,
    AccidentIncidentReport as ACI,
    OperationMaintenance as OM,
    VehicleChecklistV2,
    TrafficCount as TC,
    SafetySectionInspection as SSI,
    SiteSpecificRiskAssessment as SSRA,
    TTMSiteInspection as TTMSI,
    GardaNotificationReport as GN,
    ConfinedSpace as CS,
    WeekPlannerV2,
    FileUploader,
    HealthAndSafety as HS,
    SiteAudit as SA,
    IncidentReport as IR,
    PPEInspection as PPE,
    JcVehicleChecklist as VC,
    JcDailyWorkSheet as DWS,
    CustomReport as CR,
    CovidReport as CO,
    CovidReturnToWork as CW,
    DWDReport as DD,
    OfficeInspectionReport as OI,
    DWEReport as DE,
    DWRReport as DR,
    DWIReport as DI,
    DWMReport as DM,
    ExaminationReport as ER,
    ThreeMinuteTrafficCount as TMTC,
    ToolBoxReport,
    WalkaroundReport as WR,
    DigReport as DRR,
    SLGReport as SR,
} from "../lib";

import { tableConfig, userProfile } from "./dataConfigs";

const SLGReport = {
    ...SR,
    view: (props) => {
        return (
            <SR.view
                {...props}
                header={ProWorkHeader}
                reportType="SLGChecklist report"
            />
        );
    },
};

const ExaminationReport = {
    ...ER,
    view: (props) => {
        return (
            <ER.view
                {...props}
                header={ProWorkHeader}
                reportType="Examination report"
            />
        );
    },
};

const DWIREPORT = {
    ...DI,
    view: (props) => {
        return (
            <DI.view
                {...props}
                header={ProWorkHeader}
                reportType="Daily Weekely Tractor Report"
                //Change report background color
                // color="red"
            />
        );
    },
};

const DWRReport = {
    ...DR,
    view: (props) => {
        return (
            <DR.view
                {...props}
                header={ProWorkHeader}
                reportType="Daily Weekely Roller Report"
                //Change report background color
                // color="red"
            />
        );
    },
};

const DWEReport = {
    ...DE,
    view: (props) => {
        return (
            <DE.view
                {...props}
                header={ProWorkHeader}
                reportType="Daily Weekely Excavator Report"
                //Change report background color
                // color="red"
            />
        );
    },
};

const DigReport = {
    ...DRR,
    view: (props) => {
        return (
            <DRR.view
                {...props}
                header={ProWorkHeader}
                reportType="Scan Log / Permit To Dig Report"
            />
        );
    },
};

const DWDReport = {
    ...DD,
    view: (props) => {
        return (
            <DD.view
                {...props}
                header={ProWorkHeader}
                reportType="Daily Weekely Dumper Inspection Report"
                //Change report background color
                // color="red"
            />
        );
    },
};

const OfficeInspectionReport = {
    ...OI,
    view: (props) => {
        return (
            <OI.view
                {...props}
                header={ProWorkHeader}
                reportType="Office Inspection Report"
                //Change report background color
                // color="red"
            />
        );
    },
};

const DWMREPORT = {
    ...DM,
    view: (props) => {
        return (
            <DM.view
                {...props}
                header={ProWorkHeader}
                reportType="Daily Weekely MEWP Report"
                //Change report background color
                // color="red"
            />
        );
    },
};

const ThreeMinuteTrafficCount = {
    ...TMTC,
    view: (props) => {
        return (
            <TMTC.view
                {...props}
                header={ProWorkHeader}
                reportType="Static Traffic Count Report"
                //Change report background color
                // color="red"
            />
        );
    },
};

const JobPackManager = {
    ...JPM,
    view: (props) => {
        return <JPM.view {...props} tableConfig={tableConfig} />;
    },
};
const SiteAudit = {
    ...SA,
    view: (props) => {
        return (
            <SA.view
                {...props}
                header={ProWorkHeader}
                reportType="ProWork Site Audit"
            />
        );
    },
};
const IncidentReport = {
    ...IR,
    view: (props) => {
        return (
            <IR.view
                {...props}
                header={ProWorkHeader}
                reportType="ProWork SSWP"
            />
        );
    },
};
const HealthAndSafety = {
    ...HS,
    view: (props) => {
        return (
            <HS.view
                {...props}
                header={ProWorkHeader}
                reportType="Health and Safety"
            />
        );
    },
};
const ConfinedSpace = {
    ...CS,
    view: (props) => {
        return (
            <CS.view
                {...props}
                header={ProWorkHeader}
                reportType="Confined Space"
            />
        );
    },
};
const AccidentIncidentReport = {
    ...ACI,
    view: (props) => {
        return (
            <ACI.view
                {...props}
                header={ProWorkHeader}
                reportType="Accident & Incident Form"
            />
        );
    },
};
const GardaNotificationReport = {
    ...GN,
    view: (props) => {
        return (
            <GN.view
                {...props}
                header={ProWorkHeader}
                reportType="Garda Notification Form"
            />
        );
    },
};
const DailyWorksheet = {
    ...DW,
    view: (props) => {
        return (
            <DW.view
                {...props}
                header={ProWorkHeader}
                reportType="ProWork Daily Worksheet"
                //Change report background color
                // color="red"
            />
        );
    },
};
const TTMSiteInspection = {
    ...TTMSI,
    view: (props) => {
        return (
            <TTMSI.view
                {...props}
                header={ProWorkHeader}
                reportType="ProWork TTM Site Inspection"
                //Change report background color
                // color="red"
            />
        );
    },
};
const SafetySectionInspection = {
    ...SSI,
    view: (props) => {
        return (
            <SSI.view
                {...props}
                header={ProWorkHeader}
                reportType="ProWork Safety Section Inspection"
                //Change report background color
                // color="red"
            />
        );
    },
};
const SiteSpecificRiskAssessment = {
    ...SSRA,
    view: (props) => {
        return (
            <SSRA.view
                {...props}
                header={ProWorkHeader}
                reportType="ProWork Site Specific Risk Assessment"
                //Change report background color
                // color="red"
            />
        );
    },
};
const HD16Inspection = {
    ...HD,
    view: (props) => {
        return (
            <HD.view
                {...props}
                header={ProWorkHeader}
                reportType="ProWork HD16"
            />
        );
    },
};
const OperationMaintenance = {
    ...OM,
    view: (props) => {
        return (
            <OM.view
                {...props}
                header={ProWorkHeader}
                reportType="Operation and Maintenance Report"
            />
        );
    },
};
const BlockVehicle = {
    ...BV,
    view: (props) => {
        return (
            <BV.view
                {...props}
                header={ProWorkHeader}
                reportType="Block Vehicle Report"
            />
        );
    },
};
const TrafficCount = {
    ...TC,
    view: (props) => {
        return (
            <TC.view
                {...props}
                header={ProWorkHeader}
                reportType="Traffic Count Report"
            />
        );
    },
};
const VehicleCheckSheet = {
    ...VCS,
    view: (props) => {
        return (
            <VCS.view
                {...props}
                header={ProWorkHeader}
                reportType="Vehicle Check Sheet Report"
            />
        );
    },
};
const VehicleTrailerCheck = {
    ...VTC,
    view: (props) => {
        return (
            <VTC.view
                {...props}
                header={ProWorkHeader}
                reportType="Vehicle Trailer Check Report"
            />
        );
    },
};
const SSWPReport = {
    ...SSWP,
    view: (props) => {
        return (
            <SSWP.view
                {...props}
                header={ProWorkHeader}
                reportType="ProWork SSWP"
            />
        );
    },
};
const TMPlan = {
    ...TM,
    view: (props) => {
        return (
            <TM.view {...props} header={ProWorkHeader} reportType="TM Plan" />
        );
    },
};
const VehicleChecklist = {
    ...VehicleChecklistV2,
    view: (props) => {
        return (
            <VehicleChecklistV2.view
                {...props}
                header={ProWorkHeader}
                reportType="Vehicle Checklist"
            />
        );
    },
};
const SLGCheckList = {
    ...SLG,
    view: (props) => {
        return (
            <SLG.view
                {...props}
                header={ProWorkHeader}
                reportType="SLG Checklist"
            />
        );
    },
};
const PPEInspection = {
    ...PPE,
    view: (props) => {
        return (
            <PPE.view
                {...props}
                header={ProWorkHeader}
                reportType="PPE Inspection"
            />
        );
    },
};
const JcVehicleChecklist = {
    ...VC,
    view: (props) => {
        return (
            <VC.view
                {...props}
                header={ProWorkHeader}
                reportType="Vehicle Checklist"
            />
        );
    },
};

const CustomReport = {
    ...CR,
    view: (props) => {
        return (
            <CR.view
                {...props}
                header={ProWorkHeader}
                reportType="Custom Report"
            />
        );
    },
};

const WalkaroundReport = {
    ...WR,
    view: (props) => {
        return (
            <WR.view
                {...props}
                header={ProWorkHeader}
                reportType="Walkaround Inspection Checklist"
            />
        );
    },
};

const CovidReport = {
    ...CO,
    view: (props) => {
        return (
            <CO.view
                {...props}
                header={ProWorkHeader}
                reportType="Covid-19 Daily Safe Start Report"
            />
        );
    },
};

const CovidReturnToWork = {
    ...CW,
    view: (props) => {
        return (
            <CW.view
                {...props}
                header={ProWorkHeader}
                reportType="Covid-19 Return To Work Safely Protocol Report"
            />
        );
    },
};

const JcDailyWorkSheet = {
    ...DWS,
    view: (props) => {
        return (
            <DWS.view
                {...props}
                header={ProWorkHeader}
                reportType="Daily Worksheet"
                //Change report background color
                // color="red"
            />
        );
    },
};

const UserProfile = {
    ...UP,
    view: (props) => {
        return <UP.view {...props} userProfileKeys={userProfile} />;
    },
};
const reports = [
    {
        type: "page",
        label: "File Uploader",
        link: "/file-uploader-widget",
        component: FileUploader,
        icon: "GroupWork",
        access_level: "file_manager",
        security_level: ["Admin"],
    },
    {
        type: "page",
        label: "Jobpack Manager",
        link: "/job-pack-manager/map",
        component: JobPackManager,
        icon: "GroupWork",
        access_level: "jobpack",
        security_level: ["Admin"],
    },
    {
        type: "page",
        label: "Jobpack Manager",
        link: "/job-pack-manager/list",
        component: JobPackManager,
        icon: "GroupWork",
        access_level: "jobpack",
        security_level: ["Admin"],
    },
    {
        type: "page",
        label: "Jobpack Manager",
        link: "/job-pack-manager/roster/today",
        component: JobPackManager,
        icon: "GroupWork",
        access_level: "jobpack",
        security_level: ["Admin"],
    },
    {
        type: "page",
        label: "Jobpack Manager",
        link: "/job-pack-manager/roster/date/:startDate/:weekCount",
        component: JobPackManager,
        icon: "GroupWork",
        access_level: "jobpack",
        security_level: ["Admin"],
    },
    {
        type: "page",
        label: "Week Planner V2",
        link: "/week-planner-v2/today",
        component: WeekPlannerV2,
        icon: "GroupWork",
        access_level: "weekly_planner",
        security_level: ["Admin"],
    },
    {
        type: "page",
        label: "Week Planner V2",
        link: "/week-planner-v2/date/:startDate/:weekCount",
        component: WeekPlannerV2,
        icon: "GroupWork",
        access_level: "weekly_planner",
        security_level: ["Admin"],
    },
    {
        label: "User Profile",
        link: "/user-profile-:type/:uid",
        component: UserProfile,
        security_level: ["Admin"],
        access_level: "user_manager",
    },
    {
        label: "Toolbox Profile",
        link: "/toolbox-:type/:uid",
        component: ToolBoxProfile,
        security_level: ["Admin"],
        access_level: "toolbox_talks",
    },
    {
        label: "Toolbox Report",
        link: "/toolbox/:uid/:timestamp",
        component: ToolBoxReport,
        security_level: ["Admin"],
        access_level: "toolbox_talks",
    },
    {
        label: "Jobpack Create",
        link: "/job-pack-:type/jobpacks/:status/:year/:month/:uid/",
        component: JobPackV3,
        security_level: ["Admin"],
        access_level: "jobpack",
    },
    {
        label: "SSWP",
        key: "sswp",
        link: "/report-edit/:subject_name/:uprn/sswp/:report_id",
        component: SSWPReport,
        security_level: ["Admin"],
        access_level: "sswp",
    },
    {
        label: "SSWP",
        key: "sswp",
        link: "/report-edit/:subject_name/:uprn/sswp-custom-v2/:report_id",
        component: SSWPReport,
        security_level: ["Admin"],
        access_level: "sswp_custom_v2",
    },
    {
        label: "SSWP",
        key: "sswp",
        link: "/report-edit/:subject_name/:uprn/master-sswp-v1/:report_id",
        component: SSWPReport,
        security_level: ["Admin"],
        access_level: "master_sswp_v1",
    },
    {
        label: "SSWP",
        key: "sswp",
        link: "/report-edit/:subject_name/:uprn/master-sswp-v2/:report_id",
        component: SSWPReport,
        security_level: ["Admin"],
        access_level: "master_sswp_v2",
    },
    {
        label: "Garda Notification",
        key: "garda_notification_report",
        link:
            "/report-view/:subject_name/:status/:year/:month/:uid/garda-notification-report/:report_id",
        component: GardaNotificationReport,
        security_level: ["Admin"],
        access_level: "garda_notification_report",
    },
    {
        label: "Garda Notification",
        key: "garda_notification_report",
        link:
            "/report-view-standalone/:subject_name/:uid/garda-notification-report/:report_id",
        component: GardaNotificationReport,
        security_level: ["Admin"],
        access_level: "garda_notification_report",
    },
    {
        label: "Garda Notification",
        key: "garda_notification_report",
        link:
            "/report-edit/:subject_name/:status/:year/:month/:uid/garda-notification-report/:report_id",
        component: GardaNotificationReport,
        security_level: ["Admin"],
        access_level: "garda_notification_report",
    },
    {
        label: "PDF Viewer",
        key: "pdf_viewer",
        link:
            "/pdf-viewer/:type/jobpacks/:status/:year/:month/:uid/attached-files/:index",
        component: pdfViewer,
        security_level: ["Admin"],
        access_level: "pdf_viewer",
    },
    {
        label: "PDF Viewer",
        key: "pdf_viewer",
        link: "/pdf-viewer/:type/:index",
        component: pdfViewer,
        security_level: ["Admin"],
        access_level: "pdf_viewer",
    },
    {
        label: "PDF Viewer",
        key: "pdf_viewer",
        link: "/pdf-viewer/:type/:folder/:index",
        component: pdfViewer,
        security_level: ["Admin"],
        access_level: "pdf_viewer",
    },
    {
        label: "TM Plan",
        key: "tm_plan",
        link:
            "/report-view/:subject_name/:status/:year/:month/:uid/tm-plan/:report_id",
        component: TMPlan,
        security_level: ["Admin"],
        access_level: "tm_plan",
    },
    {
        label: "TM Plan",
        key: "tm_plan",
        link: "/report-view-standalone/:subject_name/:uid/tm-plan/:report_id",
        component: TMPlan,
        security_level: ["Admin"],
        access_level: "tm_plan",
    },
    {
        label: "Accident Report",
        key: "accident_incident_report",
        link:
            "/report-view/:subject_name/:status/:year/:month/:uid/incident-and-accident/:report_id",
        component: AccidentIncidentReport,
        security_level: ["Admin"],
        access_level: "accident_incident_report",
    },
    {
        label: "Accident Report",
        key: "accident_incident_report",
        link:
            "/report-view-standalone/:subject_name/:uid/incident-and-accident/:report_id",
        component: AccidentIncidentReport,
        security_level: ["Admin"],
        access_level: "accident_incident_report",
    },
    {
        label: "Accident Report",
        key: "accident_incident_report",
        link:
            "/report-edit/:subject_name/:uid/incident-and-accident/:report_id",
        component: AccidentIncidentReport,
        security_level: ["Admin"],
        access_level: "accident_incident_report",
    },
    {
        label: "SSWP",
        key: "sswp",
        link:
            "/report-view-standalone/:subject_name/:uprn/master-sswp-v2/:report_id",
        component: SSWPReport,
        security_level: ["Admin"],
        access_level: "sswp",
    },
    {
        label: "SSWP",
        key: "sswp",
        link:
            "/report-view/:subject_name/:status/:year/:month/:uid/master-sswp-v2/:report_id",
        component: SSWPReport,
        security_level: ["Admin"],
        access_level: "sswp",
    },

    {
        label: "SSWP",
        key: "sswp",
        link: "/report-view/:subject_name/:uprn/sswp-custom-v2/:report_id",
        component: SSWPReport,
        security_level: ["Admin"],
        access_level: "sswp_custom_v2",
    },
    {
        label: "SSWP",
        key: "sswp",
        link: "/report-view/:subject_name/:uprn/master-sswp-v1/:report_id",
        component: SSWPReport,
        security_level: ["Admin"],
        access_level: "master_sswp_v1",
    },

    {
        label: "SSWP",
        key: "sswp",
        link:
            "/report-view/:subject_name/:status/:year/:month/:uid/master-sswp-v2/:report_id",
        component: SSWPReport,
        security_level: ["Admin"],
        access_level: "master_sswp_v2",
    },

    {
        label: "Site Inspection",
        key: "tm_slg_checklist",
        link:
            "/report-view-standalone/:subject_name/:uprn/tm-slg-checklist/:report_id",
        component: SLGCheckList,
        security_level: ["Admin"],
        access_level: "tm_slg_checklist",
    },
    {
        label: "Site Inspection",
        key: "tm_slg_checklist",
        link:
            "/report-view/:subject_name/:status/:year/:month/:uprn/tm-slg-checklist/:report_id",
        component: SLGCheckList,
        security_level: ["Admin"],
        access_level: "tm_slg_checklist",
    },
    {
        label: "Site Inspection",
        key: "tm_slg_checklist",
        link: "/report-edit/:subject_name/:uprn/tm-slg-checklist/:report_id",
        component: SLGCheckList,
        security_level: ["Admin"],
        access_level: "tm_slg_checklist",
    },
    {
        label: "Site Inspection",
        key: "tm_slg_checklist",
        link:
            "/report-edit-jobpack/:subject_name/:status/:year/:month/:uid/tm-slg-checklist/:report_id",
        component: SLGCheckList,
        security_level: ["Admin"],
        access_level: "tm_slg_checklist",
    },
    {
        label: "Vehicle Checklist",
        key: "vehicle_checklist",
        link:
            "/report-view/:subject_name/:status/:year/:month/:uid/vehicle-checklist/:report_id",
        component: VehicleChecklist,
        security_level: ["Admin"],
        access_level: "vehicle_checklist",
    },
    {
        label: "Vehicle Checklist",
        key: "vehicle_checklist",
        link:
            "/report-view-standalone/:subject_name/:uid/vehicle-checklist/:report_id",
        component: VehicleChecklist,
        security_level: ["Admin"],
        access_level: "vehicle_checklist",
    },
    {
        label: "Vehicle Checklist",
        key: "vehicle_checklist",
        link: "/report-edit/:subject_name/:uid/vehicle-checklist/:report_id",
        component: VehicleChecklist,
        security_level: ["Admin"],
        access_level: "vehicle_checklist",
    },
    {
        label: "Vehicle Checklist",
        key: "vehicle_checklist",
        link:
            "/report-edit-jobpack/:subject_name/:status/:year/:month/:uid/vehicle-checklist/:report_id",
        component: VehicleChecklist,
        security_level: ["Admin"],
        access_level: "vehicle_checklist",
    },
    {
        label: "Traffic Count",
        key: "traffic_count_report",
        link:
            "/report-view-standalone/:subject_name/:uid/traffic-count-report/:report_id",
        component: TrafficCount,
        security_level: ["Admin"],
        access_level: "traffic_count_report",
    },
    {
        label: "Traffic Count",
        key: "traffic_count_report",
        link:
            "/report-view/:subject_name/:status/:year/:month/:uid/traffic-count-report/:report_id",
        component: TrafficCount,
        security_level: ["Admin"],
        access_level: "traffic_count_report",
    },
    {
        label: "Traffic Count",
        key: "traffic_count_report",
        link: "/report-edit/:subject_name/:uid/traffic-count-report/:report_id",
        component: TrafficCount,
        security_level: ["Admin"],
        access_level: "traffic_count_report",
    },
    {
        label: "Traffic Count",
        key: "traffic_count_report",
        link:
            "/report-edit-jobpack/:subject_name/:status/:year/:month/:uid/traffic-count-report/:report_id",
        component: TrafficCount,
        security_level: ["Admin"],
        access_level: "traffic_count_report",
    },
    {
        label: "Block Vehicle",
        key: "block_vehicle_check_report",
        link:
            "/report-view-standalone/:subject_name/:uid/block-vehicle-check-report/:report_id",
        component: BlockVehicle,
        security_level: ["Admin"],
        access_level: "block_vehicle_check_report",
    },
    {
        label: "Block Vehicle",
        key: "block_vehicle_check_report",
        link:
            "/report-view/:subject_name/:status/:year/:month/:uid/block-vehicle-check-report/:report_id",
        component: BlockVehicle,
        security_level: ["Admin"],
        access_level: "block_vehicle_check_report",
    },
    {
        label: "Block Vehicle",
        key: "block_vehicle_check_report",
        link:
            "/report-edit/:subject_name/:uid/block-vehicle-check-report/:report_id",
        component: BlockVehicle,
        security_level: ["Admin"],
        access_level: "block_vehicle_check_report",
    },
    {
        label: "Block Vehicle",
        key: "block_vehicle_check_report",
        link:
            "/report-edit-jobpack/:subject_name/:status/:year/:month/:uid/block-vehicle-check-report/:report_id",
        component: BlockVehicle,
        security_level: ["Admin"],
        access_level: "block_vehicle_check_report",
    },
    {
        label: "TTM Site Inspection",
        key: "ttos_ttm_site_inspection_report",
        link:
            "/report-view/:subject_name/:uid/ttos-ttm-site-inspection-report/:report_id",
        component: TTMSiteInspection,
        security_level: ["Admin"],
        access_level: "ttos_ttm_site_inspection_report",
    },
    {
        label: "TTM Site Inspection",
        key: "ttos_ttm_site_inspection_report",
        link:
            "/report-edit/:subject_name/:uid/ttos-ttm-site-inspection-report/:report_id",
        component: TTMSiteInspection,
        security_level: ["Admin"],
        access_level: "ttos_ttm_site_inspection_report",
    },
    {
        label: "Safety Section Inspection",
        key: "safety_section_inspection_report",
        link:
            "/report-view/:subject_name/:uid/safety-section-inspection-report/:report_id",
        component: SafetySectionInspection,
        security_level: ["Admin"],
        access_level: "safety_section_inspection_report",
    },
    {
        label: "Safety Section Inspection",
        key: "safety_section_inspection_report",
        link:
            "/report-edit/:subject_name/:uid/safety-section-inspection-report/:report_id",
        component: SafetySectionInspection,
        security_level: ["Admin"],
        access_level: "safety_section_inspection_report",
    },
    {
        label: "Site Specific Risk Assessment",
        key: "ssra_report",
        link:
            "/report-view-standalone/:subject_name/:uid/ssra-1-report/:report_id",
        component: SiteSpecificRiskAssessment,
        security_level: ["Admin"],
        access_level: "ssra_report",
    },
    {
        label: "Site Specific Risk Assessment",
        key: "ssra_report",
        link:
            "/report-view/:subject_name/:status/:year/:month/:uid/ssra-1-report/:report_id",
        component: SiteSpecificRiskAssessment,
        security_level: ["Admin"],
        access_level: "ssra_report",
    },
    {
        label: "Site Specific Risk Assessment",
        key: "ssra_1_report",
        link: "/report-edit/:subject_name/:uid/ssra-1-report/:report_id",
        component: SiteSpecificRiskAssessment,
        security_level: ["Admin"],
        access_level: "ssra_report",
    },
    {
        label: "Site Specific Risk Assessment",
        key: "ssra_1_report",
        link:
            "/report-edit-jobpack/:subject_name/:status/:year/:month/:uid/ssra-1-report/:report_id",
        component: SiteSpecificRiskAssessment,
        security_level: ["Admin"],
        access_level: "ssra_report",
    },
    {
        label: "Operation and Maintenance Report",
        key: "operation_and_maintenance_report",
        link:
            "/report-view-standalone/:subject_name/:uid/operation-and-maintenance-report/:report_id",
        component: OperationMaintenance,
        security_level: ["Admin"],
        access_level: "operation_and_maintenance_report",
    },
    {
        label: "Operation and Maintenance Report",
        key: "operation_and_maintenance_report",
        link:
            "/report-view/:subject_name/:status/:year/:month/:uid/operation-and-maintenance-report/:report_id",
        component: OperationMaintenance,
        security_level: ["Admin"],
        access_level: "operation_and_maintenance_report",
    },
    {
        label: "Operation and Maintenance Report",
        key: "operation_and_maintenance_report",
        link:
            "/report-edit/:subject_name/:uid/operation-and-maintenance-report/:report_id",
        component: OperationMaintenance,
        security_level: ["Admin"],
        access_level: "operation_and_maintenance_report",
    },
    {
        label: "Operation and Maintenance Report",
        key: "operation_and_maintenance_report",
        link:
            "/report-edit-jobpack/:subject_name/:status/:year/:month/:uid/operation-and-maintenance-report/:report_id",
        component: OperationMaintenance,
        security_level: ["Admin"],
        access_level: "operation_and_maintenance_report",
    },
    {
        label: "Trailer Vehicle Check",
        key: "trailer_vehicle_check_report",
        link:
            "/report-view-standalone/:subject_name/:uid/trailer-vehicle-check-report/:report_id",
        component: VehicleTrailerCheck,
        security_level: ["Admin"],
        access_level: "trailer_vehicle_check_report",
    },
    {
        label: "Trailer Vehicle Check",
        key: "trailer_vehicle_check_report",
        link:
            "/report-view/:subject_name/:status/:year/:month/:uid/trailer-vehicle-check-report/:report_id",
        component: VehicleTrailerCheck,
        security_level: ["Admin"],
        access_level: "trailer_vehicle_check_report",
    },
    {
        label: "Trailer Vehicle Check",
        key: "trailer_vehicle_check_report",
        link:
            "/report-edit/:subject_name/:uid/trailer-vehicle-check-report/:report_id",
        component: VehicleTrailerCheck,
        security_level: ["Admin"],
        access_level: "trailer_vehicle_check_report",
    },
    {
        label: "Trailer Vehicle Check",
        key: "trailer_vehicle_check_report",
        link:
            "/report-edit-jobpack/:subject_name/:status/:year/:month/:uid/trailer-vehicle-check-report/:report_id",
        component: VehicleTrailerCheck,
        security_level: ["Admin"],
        access_level: "trailer_vehicle_check_report",
    },
    {
        label: "Vehicle Check Sheet",
        key: "vehicle_check_sheet_report",
        link:
            "/report-view-standalone/:subject_name/:uid/vehicle-check-sheet-report/:report_id",
        component: VehicleCheckSheet,
        security_level: ["Admin"],
        access_level: "vehicle_check_sheet_report",
    },
    {
        label: "Vehicle Check Sheet",
        key: "vehicle_check_sheet_report",
        link:
            "/report-view/:subject_name/:status/:year/:month/:uid/vehicle-check-sheet-report/:report_id",
        component: VehicleCheckSheet,
        security_level: ["Admin"],
        access_level: "vehicle_check_sheet_report",
    },
    {
        label: "Vehicle Check Sheet",
        key: "vehicle_check_sheet_report",
        link:
            "/report-edit/:subject_name/:uid/vehicle-check-sheet-report/:report_id",
        component: VehicleCheckSheet,
        security_level: ["Admin"],
        access_level: "vehicle_check_sheet_report",
    },
    {
        label: "Vehicle Check Sheet",
        key: "vehicle_check_sheet_report",
        link:
            "/report-edit-jobpack/:subject_name/:status/:year/:month/:uid/vehicle-check-sheet-report/:report_id",
        component: VehicleCheckSheet,
        security_level: ["Admin"],
        access_level: "vehicle_check_sheet_report",
    },
    {
        label: "HD16 Inspection",
        key: "hd16_inspection_report",
        link:
            "/report-view-standalone/:subject_name/:uprn/hd16-inspection-report/:report_id",
        component: HD16Inspection,
        security_level: ["Admin"],
        access_level: "hd16_inspection_report",
    },
    {
        label: "HD16 Inspection",
        key: "hd16_inspection_report",
        link:
            "/report-view/:subject_name/:status/:year/:month/:uprn/hd16-inspection-report/:report_id",
        component: HD16Inspection,
        security_level: ["Admin"],
        access_level: "hd16_inspection_report",
    },
    {
        label: "HD16 Inspection",
        key: "hd16_inspection_report",
        link:
            "/report-edit/:subject_name/:uprn/hd16-inspection-report/:report_id",
        component: HD16Inspection,
        security_level: ["Admin"],
        access_level: "hd16_inspection_report",
    },
    {
        label: "HD16 Inspection",
        key: "hd16_inspection_report",
        link:
            "/report-edit-jobpack/:subject_name/:status/:year/:month/:uprn/hd16-inspection-report/:report_id",
        component: HD16Inspection,
        security_level: ["Admin"],
        access_level: "hd16_inspection_report",
    },

    {
        label: "HD16 Inspection",
        key: "hd16_audit_report",
        link:
            "/report-view/:subject_name/:status/:year/:month/:uprn/hd16-audit-report/:report_id",
        component: HD16Inspection,
        security_level: ["Admin"],
        access_level: "hd16_audit_report",
    },
    {
        label: "HD16 Inspection",
        key: "hd16_audit_report",
        link:
            "/report-view-standalone/:subject_name/:uprn/hd16-audit-report/:report_id",
        component: HD16Inspection,
        security_level: ["Admin"],
        access_level: "hd16_audit_report",
    },
    {
        label: "HD16 Inspection",
        key: "hd16_audit_report",
        link: "/report-edit/:subject_name/:uprn/hd16-audit-report/:report_id",
        component: HD16Inspection,
        security_level: ["Admin"],
        access_level: "hd16_audit_report",
    },
    {
        label: "HD16 Inspection",
        key: "hd16_audit_report",
        link:
            "/report-edit-jobpack/:subject_name/:status/:year/:month/:uprn/hd16-audit-report/:report_id",
        component: HD16Inspection,
        security_level: ["Admin"],
        access_level: "hd16_audit_report",
    },
    {
        label: "Daily Worksheet",
        key: "prowork_generic_daily_worksheet_v1",
        link:
            "/report-view/:subject_name/:status/:year/:month/:uprn/prowork-generic-daily-worksheet-v1/:report_id",
        component: DailyWorksheet,
        security_level: ["Admin"],
        access_level: "prowork_generic_daily_worksheet_v1",
    },
    {
        label: "Daily Worksheet",
        key: "prowork_generic_daily_worksheet_v1",
        link:
            "/report-view-standalone/:subject_name/:uprn/prowork-generic-daily-worksheet-v1/:report_id",
        component: DailyWorksheet,
        security_level: ["Admin"],
        access_level: "prowork_generic_daily_worksheet_v1",
    },
    {
        label: "Daily Worksheet",
        key: "prowork_generic_daily_worksheet_v1",
        link:
            "/report-edit/:subject_name/:uprn/prowork-generic-daily-worksheet-v1/:report_id",
        component: DailyWorksheet,
        security_level: ["Admin"],
        access_level: "prowork_generic_daily_worksheet_v1",
    },
    {
        label: "Daily Worksheet",
        key: "prowork_generic_daily_worksheet_v1",
        link:
            "/report-edit-jobpack/:subject_name/:status/:year/:month/:uprn/prowork-generic-daily-worksheet-v1/:report_id",
        component: DailyWorksheet,
        security_level: ["Admin"],
        access_level: "prowork_generic_daily_worksheet_v1",
    },
    {
        label: "Confined Space",
        key: "jcenviro_confined_space",
        link:
            "/report-view/:subject_name/:status/:year/:month/:uprn/jcenviro-confined-space/:report_id",
        component: ConfinedSpace,
        security_level: ["Admin"],
        access_level: "jcenviro_confined_space",
    },
    {
        label: "Confined Space",
        key: "jcenviro_confined_space",
        link:
            "/report-view-standalone/:subject_name/:uprn/jcenviro-confined-space/:report_id",
        component: ConfinedSpace,
        security_level: ["Admin"],
        access_level: "jcenviro_confined_space",
    },
    {
        label: "Health And Safety Induction Form",
        key: "jcenviro_health_and_safety_induction",
        link:
            "/report-view/:subject_name/:status/:year/:month/:uprn/jcenviro-health-and-safety-induction/:report_id",
        component: HealthAndSafety,
        access_level: ["Level 0", "Level 1", "Level 2", "Level 3", "Level 4"],
        security_level: ["Admin"],
    },
    {
        label: "Health And Safety Induction Form",
        key: "jcenviro_health_and_safety_induction",
        link:
            "/report-view-standalone/:subject_name/:uprn/jcenviro-health-and-safety-induction/:report_id",
        component: HealthAndSafety,
        access_level: "jcenviro_health_and_safety_induction",
        security_level: ["Admin"],
    },
    {
        label: "Site Audit",
        key: "jcenviro_site_audit",
        link:
            "/report-view-standalone/:subject_name/:uprn/jcenviro-site-audit/:report_id",
        component: SiteAudit,
        access_level: "jcenviro_site_audit",
        security_level: ["Admin"],
    },
    {
        label: "Site Audit",
        key: "jcenviro_site_audit",
        link:
            "/report-view/:subject_name/:status/:year/:month/:uprn/jcenviro-site-audit/:report_id",
        component: SiteAudit,
        access_level: "jcenviro_site_audit",
        security_level: ["Admin"],
    },
    {
        label: "Site Audit",
        key: "jcenviro_site_audit",
        link: "/report-edit/:subject_name/:uprn/jcenviro-site-audit/:report_id",
        component: SiteAudit,
        access_level: ["Level 0", "Level 1", "Level 2", "Level 3", "Level 4"],
        security_level: ["Admin"],
    },
    {
        label: "Site Audit",
        key: "jcenviro_site_audit",
        link:
            "/report-edit-jobpack/:subject_name/:status/:year/:month/:uprn/jcenviro-site-audit/:report_id",
        component: SiteAudit,
        access_level: "jcenviro_site_audit",
        security_level: ["Admin"],
    },
    {
        label: "Incident Report",
        key: "jcenviro_incident_near_miss",
        link:
            "/report-view/:subject_name/:status/:year/:month/:uprn/jcenviro-incident-near-miss/:report_id",
        component: IncidentReport,
        access_level: "jcenviro_incident_near_miss",
        security_level: ["Admin"],
    },
    {
        label: "Incident Report",
        key: "incident_report",
        link:
            "/report-view-standalone/:subject_name/:uprn/jcenviro-incident-near-miss/:report_id",
        component: IncidentReport,
        access_level: "jcenviro_incident_near_miss",
        security_level: ["Admin"],
    },
    {
        label: "Incident Report",
        key: "incident_report",
        link:
            "/report-edit/:subject_name/:uprn/jcenviro-incident-near-miss/:report_id",
        component: IncidentReport,
        access_level: ["Level 0", "Level 1", "Level 2", "Level 3", "Level 4"],
        security_level: ["Admin"],
    },
    {
        label: "Incident Report",
        key: "incident_report",
        link:
            "/report-edit-jobpack/:subject_name/:status/:year/:month/:uprn/jcenviro-incident-near-miss/:report_id",
        component: IncidentReport,
        access_level: ["Level 0", "Level 1", "Level 2", "Level 3", "Level 4"],
        security_level: ["Admin"],
    },
    {
        label: "Daily WorkSheet",
        key: "jcenviro_daily_worksheet",
        link:
            "/report-view-standalone/:subject_name/:uprn/jcenviro-daily-worksheet/:report_id",
        component: JcDailyWorkSheet,
        access_level: ["jcenviro_daily_worksheet"],
        security_level: ["Admin"],
    },
    {
        label: "Daily WorkSheet",
        key: "jcenviro_daily_worksheet",
        link:
            "/report-view/:subject_name/:status/:year/:month/:uprn/jcenviro-daily-worksheet/:report_id",
        component: JcDailyWorkSheet,
        access_level: ["jcenviro_daily_worksheet"],
        security_level: ["Admin"],
    },
    {
        label: "Daily WorkSheet",
        key: "jcenviro_daily_worksheet",
        link:
            "/report-edit/:subject_name/:uprn/jcenviro-daily-worksheet/:report_id",
        component: JcDailyWorkSheet,
        access_level: ["jcenviro_daily_worksheet"],
        security_level: ["Admin"],
    },
    {
        label: "Daily WorkSheet",
        key: "jcenviro_daily_worksheet",
        link:
            "/report-edit-jobpack/:subject_name/:status/:year/:month/:uprn/jcenviro-daily-worksheet/:report_id",
        component: JcDailyWorkSheet,
        access_level: ["jcenviro_daily_worksheet"],
        security_level: ["Admin"],
    },
    {
        label: "PPE Inspection",
        key: "jcenviro_ppe_inspection",
        link:
            "/report-view/:subject_name/:status/:year/:month/:uprn/jcenviro-ppe-inspection/:report_id",
        component: PPEInspection,
        security_level: ["Admin"],
        access_level: "jcenviro_ppe_inspection",
    },
    {
        label: "PPE Inspection",
        key: "jcenviro_ppe_inspection",
        link:
            "/report-view-standalone/:subject_name/:uprn/jcenviro-ppe-inspection/:report_id",
        component: PPEInspection,
        access_level: ["Level 0", "Level 1", "Level 2", "Level 3", "Level 4"],
        security_level: ["Admin"],
    },
    {
        label: "Vehicle Checklist",
        key: "jcenviro_vehicle_checklist",
        link:
            "/report-view-standalone/:subject_name/:uprn/jcenviro-vehicle-checklist/:report_id",
        component: JcVehicleChecklist,
        access_level: ["Level 0", "Level 1", "Level 2", "Level 3", "Level 4"],
        security_level: ["Admin"],
    },
    {
        label: "Vehicle Checklist",
        key: "jcenviro_vehicle_checklist",
        link:
            "/report-view/:subject_name/:status/:year/:month/:uprn/jcenviro-vehicle-checklist/:report_id",
        component: JcVehicleChecklist,
        security_level: ["Admin"],
        access_level: ["Level 0", "Level 1", "Level 2", "Level 3", "Level 4"],
    },
    {
        label: "Custom Report",
        key: "custom_report",
        link:
            "/report-view-standalone/:subject_name/:uprn/custom-report/:report_id",
        component: CustomReport,
        access_level: ["custom_report"],
        security_level: ["Admin"],
    },
    {
        label: "Custom Report",
        key: "custom_report",
        link:
            "/report-view/:subject_name/:status/:year/:month/:uprn/custom-report/:report_id",
        component: CustomReport,
        security_level: ["Admin"],
        access_level: ["custom_report"],
    },
    {
        label: "Walkaround Report",
        key: "walkaround_inspection_checklist",
        link:
            "/report-view-standalone/:subject_name/:uprn/walkaround-inspection-checklist/:report_id",
        component: WalkaroundReport,
        access_level: ["walkaround_inspection_checklist"],
        security_level: ["Admin"],
    },
    {
        label: "Walkaround Report",
        key: "walkaround_inspection_checklist",
        link:
            "/report-view/:subject_name/:status/:year/:month/:uprn/walkaround-inspection-checklist/:report_id",
        component: WalkaroundReport,
        security_level: ["Admin"],
        access_level: ["walkaround_inspection_checklist"],
    },
    {
        label: "Covid-19 : Daily Safe Start Report",
        key: "covid_daily_safe_start",
        link:
            "/report-view-standalone/:subject_name/:uprn/covid-daily-safe-start/:report_id",
        component: CovidReport,
        access_level: ["covid_daily_safe_start"],
        security_level: ["Admin"],
    },
    {
        label: "Covid-19 : Daily Safe Start Report",
        key: "covid_daily_safe_start",
        link:
            "/report-view/:subject_name/:status/:year/:month/:uprn/covid-daily-safe-start/:report_id",
        component: CovidReport,
        security_level: ["Admin"],
        access_level: ["covid_daily_safe_start"],
    },
    {
        label: "Covid-19 Return To Work Safely Protocol Report",
        key: "covid_return_to_work",
        link:
            "/report-view-standalone/:subject_name/:uprn/covid-return-to-work/:report_id",
        component: CovidReturnToWork,
        access_level: ["covid_return_to_work"],
        security_level: ["Admin"],
    },
    {
        label: "Covid-19 Return To Work Safely Protocol Report",
        key: "covid_return_to_work",
        link:
            "/report-view/:subject_name/:status/:year/:month/:uprn/covid-return-to-work/:report_id",
        component: CovidReturnToWork,
        security_level: ["Admin"],
        access_level: ["covid_return_to_work"],
    },
    {
        label: "Daily/Weekely Dumper Inspection Report",
        key: "daily_weekly_dumper_inspection",
        link:
            "/report-view-standalone/:subject_name/:uid/daily-weekly-dumper-inspection/:report_id",
        component: DWDReport,
        security_level: ["Admin"],
        access_level: ["Level 0", "Level 1", "Level 2", "Level 3", "Level 4"],
    },
    {
        label: "Daily/Weekely Dumper Inspection Report",
        key: "daily_weekly_dumper_inspection",
        link:
            "/report-view/:subject_name/:status/:year/:month/:uid/daily-weekly-dumper-inspection/:report_id",
        component: DWDReport,
        security_level: ["Admin"],
        access_level: ["Level 0", "Level 1", "Level 2", "Level 3", "Level 4"],
    },
    {
        label: "Office Inspection Report",
        key: "dcc_office_inspection",
        link:
            "/report-view-standalone/:subject_name/:uid/dcc-office-inspection/:report_id",
        component: OfficeInspectionReport,
        security_level: ["Admin"],
        access_level: ["Level 0", "Level 1", "Level 2", "Level 3", "Level 4"],
    },
    {
        label: "Office Inspection Report",
        key: "dcc_office_inspection",
        link:
            "/report-view/:subject_name/:status/:year/:month/:uid/dcc-office-inspection/:report_id",
        component: OfficeInspectionReport,
        security_level: ["Admin"],
        access_level: ["Level 0", "Level 1", "Level 2", "Level 3", "Level 4"],
    },
    {
        label: "Daily Weekely Excavator Report",
        key: "daily_weekly_excavator_inspection",
        link:
            "/report-view-standalone/:subject_name/:uid/daily-weekly-excavator-inspection/:report_id",
        component: DWEReport,
        security_level: ["Admin"],
        access_level: ["Level 0", "Level 1", "Level 2", "Level 3", "Level 4"],
    },
    {
        label: "Daily Weekely Excavator Report",
        key: "daily_weekly_excavator_inspection",
        link:
            "/report-view/:subject_name/:status/:year/:month/:uid/daily-weekly-excavator-inspection/:report_id",
        component: DWEReport,
        security_level: ["Admin"],
        access_level: ["Level 0", "Level 1", "Level 2", "Level 3", "Level 4"],
    },
    {
        label: "Daily Weekely Roller Report",
        key: "daily_weekly_roller_inspection",
        link:
            "/report-view-standalone/:subject_name/:uid/daily-weekly-roller-inspection/:report_id",
        component: DWRReport,
        security_level: ["Admin"],
        access_level: ["Level 0", "Level 1", "Level 2", "Level 3", "Level 4"],
    },
    {
        label: "Daily Weekely Roller Report",
        key: "daily_weekly_roller_inspection",
        link:
            "/report-view/:subject_name/:status/:year/:month/:uid/daily-weekly-roller-inspection/:report_id",
        component: DWRReport,
        security_level: ["Admin"],
        access_level: ["Level 0", "Level 1", "Level 2", "Level 3", "Level 4"],
    },
    {
        label: "Daily Weekely Tractor Report",
        key: "daily_weekly_tractor_inspection",
        link:
            "/report-view-standalone/:subject_name/:uid/daily-weekly-tractor-inspection/:report_id",
        component: DWIREPORT,
        security_level: ["Admin"],
        access_level: ["Level 0", "Level 1", "Level 2", "Level 3", "Level 4"],
    },
    {
        label: "Daily Weekely Tractor Report",
        key: "daily_weekly_tractor_inspection",
        link:
            "/report-view/:subject_name/:status/:year/:month/:uid/daily-weekly-tractor-inspection/:report_id",
        component: DWIREPORT,
        security_level: ["Admin"],
        access_level: ["Level 0", "Level 1", "Level 2", "Level 3", "Level 4"],
    },
    {
        label: "Daily Weekely MEWP Report",
        key: "daily_weekly_mewp_inspection",
        link:
            "/report-view-standalone/:subject_name/:uid/daily-weekly-mewp-inspection/:report_id",
        component: DWMREPORT,
        security_level: ["Admin"],
        access_level: ["Level 0", "Level 1", "Level 2", "Level 3", "Level 4"],
    },
    {
        label: "Daily Weekely MEWP Report",
        key: "daily_weekly_mewp_inspection",
        link:
            "/report-view/:subject_name/:status/:year/:month/:uid/daily-weekly-mewp-inspection/:report_id",
        component: DWMREPORT,
        security_level: ["Admin"],
        access_level: ["Level 0", "Level 1", "Level 2", "Level 3", "Level 4"],
    },
    {
        label: "Examination Report",
        key: "plant_equipment_examination_report",
        link:
            "/report-view-standalone/:subject_name/:uid/plant-equipment-examination-report/:report_id",
        component: ExaminationReport,
        security_level: ["Admin"],
        access_level: ["Level 0", "Level 1", "Level 2", "Level 3", "Level 4"],
    },
    {
        label: "Examination Report",
        key: "plant_equipment_examination_report",
        link:
            "/report-view/:subject_name/:status/:year/:month/:uid/plant-equipment-examination-report/:report_id",
        component: ExaminationReport,
        security_level: ["Admin"],
        access_level: ["Level 0", "Level 1", "Level 2", "Level 3", "Level 4"],
    },
    {
        label: "Three Minute Traffic Count",
        key: "three_minute_traffic_count",
        link:
            "/report-view-standalone/:subject_name/:uid/three-minute-traffic-count/:report_id",
        component: ThreeMinuteTrafficCount,
        security_level: ["Admin"],
        access_level: ["Level 0", "Level 1", "Level 2", "Level 3", "Level 4"],
    },
    {
        label: "Three Minute Traffic Count",
        key: "three_minute_traffic_count",
        link:
            "/report-view/:subject_name/:status/:year/:month/:uid/three-minute-traffic-count/:report_id",
        component: ThreeMinuteTrafficCount,
        security_level: ["Admin"],
        access_level: ["Level 0", "Level 1", "Level 2", "Level 3", "Level 4"],
    },
    {
        label: "Scan Log / Permit To Dig Report",
        key: "tli_scan_log_permit_to_dig",
        link:
            "/report-view-standalone/:subject_name/:uprn/tli-scan-log-permit-to-dig/:report_id",
        component: DigReport,
        access_level: ["tli_scan_log_permit_to_dig"],
        security_level: ["Admin"],
    },
    {
        label: "Scan Log / Permit To Dig Report",
        key: "tli_scan_log_permit_to_dig",
        link:
            "/report-view/:subject_name/:status/:year/:month/:uprn/tli-scan-log-permit-to-dig/:report_id",
        component: DigReport,
        security_level: ["Admin"],
        access_level: ["tli_scan_log_permit_to_dig"],
    },
    {
        label: "SLGReport",
        key: "tm_slg_checklist_v2",
        link:
            "/report-view-standalone/:subject_name/:uprn/tm-slg-checklist-v2/:report_id",
        component: SLGReport,
        access_level: ["tm_slg_checklist_v2"],
        security_level: ["Admin"],
    },
    {
        label: "SLGReport",
        key: "tm_slg_checklist_v2",
        link:
            "/report-view/:subject_name/:status/:year/:month/:uprn/tm-slg-checklist-v2/:report_id",
        component: SLGReport,
        security_level: ["Admin"],
        access_level: ["tm_slg_checklist_v2"],
    },
];
export default reports;
